import { useState, useEffect } from "react";
import { defaultStartFor, isSingleDayMode, todayKey } from "../../utils/defaultRange";
import { ChartControls } from "../../components/Channel";
import TuneInOutChart from "../../components/charts3/TuneInOutChart";

import { useDaysSorted } from "../../hooks/useDaysSorted";
import { useUserJourneyLogger } from "../../hooks/useUserJourneyLogger";
import { useTuneInOutSeries } from "../../hooks/useTuneInOutSeries";

const TIO_MODES = ["minute", "hour", "day", "week", "month"];

export default function ChannelTuneInOut({
  channelId,
  rawImpressions,
  rawVideo,
  loading,
  refreshKey,
  refreshEnabled,
  setRefreshEnabled,
  refreshIntervalMin,
  setRefreshIntervalMin,
  refreshCountdown,
  manualRefresh,
}) {
  const storedUser = JSON.parse(localStorage.getItem("adm_panel_user") || "{}");
  const defaultMode = storedUser.chartdefault || "minute";
  const [mode, setMode] = useState(defaultMode);

  const [startTime, setStartTime] = useState("00:00");
  const [endTime, setEndTime] = useState("23:59");

  // Independent date state for this chart
  const [endDateInput, setEndDateInput] = useState(todayKey);
  const [startDateInput, setStartDateInput] = useState(() =>
    defaultStartFor(defaultMode, todayKey())
  );

  // The single-day picker reports only a start, so the end follows it there.
  const handleStartDateChange = (val) => {
    setStartDateInput(val);
    if (isSingleDayMode(mode)) setEndDateInput(val);
  };


  const sortedKeys = useDaysSorted(rawImpressions);

  const { tuneIn, tuneOut } = useTuneInOutSeries({
    rawImpressions,
    rawVideo,
    sortedImpKeys: sortedKeys,
    startDateInput,
    endDateInput,
    startTime,
    endTime,
    mode,
  });

  const { logPageChange, logTimeframeChange } = useUserJourneyLogger({
    channelId,
  });

  useEffect(() => {
    logPageChange({ chartType: "tuneinout" });
  }, [logPageChange]);

  const handleModeChange = (newMode) => {
    setMode(newMode);
    setStartDateInput(defaultStartFor(newMode, endDateInput));
    logTimeframeChange({
      chartType: "tuneinout",
      mode: newMode,
    });
  };

  return (
    <>
      <ChartControls
        channelId={channelId}
        mode={mode}
        onModeChange={handleModeChange}
        allowedModes={TIO_MODES}
        startDateInput={startDateInput}
        endDateInput={endDateInput}
        onStartDateChange={handleStartDateChange}
        onEndDateChange={setEndDateInput}
        startTime={startTime}
        endTime={endTime}
        onStartTimeChange={setStartTime}
        onEndTimeChange={setEndTime}
        refreshEnabled={refreshEnabled}
        onRefreshToggle={setRefreshEnabled}
        refreshIntervalMin={refreshIntervalMin}
        onRefreshIntervalChange={setRefreshIntervalMin}
        countdown={refreshCountdown}
        onManualRefresh={manualRefresh}
      />

      {!loading ? (
        <TuneInOutChart
          tuneIn={tuneIn}
          tuneOut={tuneOut}
          mode={mode}          // ✅ gerekli
          refreshKey={refreshKey}
        />
      ) : (
        <div className="chart-container">
          <h3 className="chart-title">Tune-in / Tune-out</h3>
          <div className="chart-loading">
            <div className="chart-skeleton" />
            <div className="chart-loading-text">Loading chart...</div>
          </div>
        </div>
      )}
    </>
  );
}